import React, { ReactElement } from 'react'
import { clientInfo } from 'configureBrand'
import { translate } from 'helpers'
import { P, Wrapper } from './subcomponents'

const LegalText = (): ReactElement => (
  <Wrapper>
    <P>{translate({ string: 'legalText', argument: clientInfo.vanityUrl })}</P>
  </Wrapper>
)

export default LegalText
